
import Image from '@/components/Image.vue'
import OverviewBox from '@/components/overview/OverviewBox.vue'
import { IFractionBoxData } from '@/__types__/overview'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'FractionsBox',
  props: {
    data: {
      type: Object as PropType<IFractionBoxData>,
      required: true,
    },
  },
  components: { OverviewBox, Image },
})
